import { Component, OnInit, ElementRef, ViewChild, OnDestroy } from '@angular/core';

import { HTTPService, HelperService, DataService } from 'app/services';
import { ConfirmDismissDialogComponent } from 'app/modules/shared/components';

import { find } from 'lodash';
import { DialogService } from 'primeng/dynamicdialog';
import { Subscription } from 'rxjs';
@Component({
    selector: 'app-tire-storage-sidepanel',
    templateUrl: './tire-storage-sidepanel.component.html',
    styleUrls: ['./tire-storage-sidepanel.component.scss'],
    providers: [DialogService],
})
export class TireStorageSidepanelComponent implements OnInit, OnDestroy {
  @ViewChild('sidebarContainer', { static: true }) sidebarContainer: ElementRef;

  dataListeners: any[] = [];
  clickOutsideListener: Subscription;
  customer: any = {};
  vehicle: any = {};
  customerSearchKey: string = '';
  tireStorages: any[] = [];
  selectedIndex: number = 0;
  customFleetSettings: any = {};
  estimateURL: string = '';
  isSidebarVisible: boolean = false;
  estimateData: any = {};
  isProcessing: boolean = false;
  isTireScheduleForReturn: boolean = false;
  isQTQModalAlreadyOpen: boolean = false;

  tirePositionOptionsMapping: any = {
    FL: 'Front left (FL)',
    FR: 'Front right (FR)',
    RL: 'Rear left (RL)',
    RR: 'Rear right (RR)',
    S1: 'Spare 1',
    S2: 'Spare 2'
  };

  constructor(private dataService: DataService, 
    private helperService: HelperService, 
    private httpService: HTTPService,
    private dialogService: DialogService) {}

  ngOnInit(): void {
    this.setDataListener();
  }

  ngOnDestroy(): void {
    this.dataListeners.forEach((subscribe) => {
      if (subscribe) {
        subscribe.unsubscribe();
      }
    });
  }

  handleResetData(){
    this.handleUnsubscribleClickoutside();
    this.customer = {};
    this.vehicle = {};
    this.tireStorages = [];
    this.selectedIndex = 0;
    this.customFleetSettings = {};
    this.estimateURL = '';
    this.customerSearchKey = '';
    this.estimateData = {};
    this.isProcessing = false;
    this.isTireScheduleForReturn = false;
    this.isQTQModalAlreadyOpen = false;
    this.isSidebarVisible = false;
  }

  setDataListener() {
    this.dataListeners.push(
      this.dataService.getData().subscribe((payload: any) => {
        if (!payload) return;

        const { type, openFrom, data, key } = payload.data;

        if (type === 'tire-storage-sidedrawer') {
          this.isSidebarVisible = true;
          this.customer = data?.customer || {};
          this.vehicle = data?.vehicle || {};
          this.customFleetSettings = data?.customFleetSettings || {};
          this.customerSearchKey =  data?.customer?.displayName || '';
          this.tireStorages = this.formatTireStorageData(data?.tireStorages || []);
          this.isTireScheduleForReturn = data?.isTireScheduleForReturn || false;
          this.estimateURL = data?.estimateURL || '';
          if(this.tireStorages?.length) {
            this.handleRadioChange(0);
          }
          this.setClickOutsideListener();
        } else if(key === 'tire-storge-flow-ro-created') {
          this.isQTQModalAlreadyOpen = false;
          const { estimate, url } = data.data;
          if(url) {
            this.estimateURL = url;
            this.estimateData = estimate || '';
          }
        } else if(key === 'qtq-modal-closed') {
          this.isQTQModalAlreadyOpen = false;
        }
        
      }),
    );
  }

  openEstimate(url: string, estimateId: string) {
    this.helperService.openPageInNewExistingTab(url, estimateId);
  }

  handleScheduleReturn() {
    if(this.isTireScheduleForReturn) {
      this.handleResetData();
      return;
    }

    if(this.isProcessing) {
      return;
    }

    if(this.estimateData?._id) {
      const text = 'Tire swap with new tires';
      this.createTireStorageEstimate({
        customerId: this.customer?.customerId,
        vehicleId: this.vehicle?.vehicleId,
        tireStorageId: this.tireStorages[this.selectedIndex]?._id,
        estimateId: this.estimateData?._id
      }, 'swap', text);

      // this.dataService.sendData(this.dataService.typePassData('tire-storage-ro-schedule-return', {estimateData: this.helperService.deepCopy(this.estimateData), concernText: text, estimateURL: this.estimateURL}));
      // this.handleResetData();
    } else {
      if(this.tireStorages?.length) {
        this.openConfirmationModal({
          customerId: this.customer?.customerId,
          vehicleId: this.vehicle?.vehicleId,
          tireStorageId: this.tireStorages[this.selectedIndex]?._id
        }, 'swap');
      }
      
    }
  }

  openConfirmationModal(data: any, type) {
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '35%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      closeOnEscape: false,
      data: {
        title: 'Are you sure you want to continue?',
        message: 'A new repair order will be generated with the selected Tire storage populated for return/swap.',
        button: {
          success: { title: 'Confirm' },
          cancel: { title: 'Cancel' },
        },
      },
    });

    const onCloseSub = ref.onClose.subscribe(({ isSuccess }) => {
      if (isSuccess) {
        const text = 'Seasonal tire swap';
        this.createTireStorageEstimate(data, type, text);
      } else {
        this.isProcessing = false;
      }

      onCloseSub.unsubscribe();
    });
  }

  createTireStorageEstimate(data: any, type: string, concernTextMsg: string) {
    const { customerId, vehicleId, tireStorageId, estimateId } = data;
    let payload: any = { customerId, vehicleId, tireStorageIds: [tireStorageId], createType: type, tireSwape: true, browserSessionId: Date.now(), isTireScheduleForReturn: true }
    if(estimateId) {
      payload.estimateId = estimateId;
    }
    this.isProcessing = true;
    this.httpService
      .createTireStorageEstimate(payload)
      .then(
        (order: any) => {
          this.isProcessing = false;
          if (order) {
            const queryParams = {
              browserSessionToken: order.restriction.token || '',
              checkPreferredLocation: order.checkPreferredLocation || false,
            };
            
            const url = this.helperService.constructQueryParams(`/estimate/${order._id}`, queryParams);
            this.dataService.sendData(this.dataService.typePassData('tire-storage-ro-schedule-return', {estimateData: order, concernText: concernTextMsg, estimateURL: url, tireStorageId}));
            this.handleResetData();
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
        this.isProcessing = false;
      });
  }

  formatTireStorageData(tiresStorages: any[]): Array<any>[] {
    tiresStorages?.forEach((item: any) => {
      if(item.tiresInfo?.length) {
        item.seasonality = item.tiresInfo[0].seasonality;
        item.location = '';
        if(item.tiresInfo[0]?.storageLocation) {
          item.location = item.tiresInfo[0]?.storageLocation?.name
        }
        if(item.tiresInfo[0].storageBin) {
          item.location += `-${item.tiresInfo[0]?.storageBin?.name}`;
        }
      }
    });
    return tiresStorages;
  }
  
  setClickOutsideListener() {
    this.clickOutsideListener = this.dataService.getClickEvent().subscribe((target) => {
      const sidebarShade = document.querySelector('.p-sidebar-mask');

      if (sidebarShade && sidebarShade.contains(target)) {
        this.onSidebarOutside();
      }
    });
  }

  onSidebarOutside() {
    this.isSidebarVisible = false;
  }

  handleUnsubscribleClickoutside() {
    if (this.clickOutsideListener) {
      this.clickOutsideListener.unsubscribe();
    }

    this.clickOutsideListener = null;
  }

  dismissSidePanel() {
    this.handleResetData();
  }

  openQTQModal() {
    if(this.isQTQModalAlreadyOpen) {
      return;
    }
    if(this.tireStorages?.length) {
      this.isQTQModalAlreadyOpen = true;
      this.dataService.sendData(
        this.dataService.typePassData('open-qtq-ts-dialog', {
          type: 'open-qtq-ts-dialog',
          isOpenFromRO: false,
          payload: {
            customer: this.helperService.deepCopy(this.customer),
            vehicle: this.helperService.deepCopy(this.vehicle),
            customFleetSettings: this.helperService.deepCopy(this.customFleetSettings),
            tireStorageId: this.tireStorages[this.selectedIndex]?._id
          },
        })
      );
    }
  }

  handleRadioChange(itemIndex: any) {
    this.selectedIndex = itemIndex;
    this.getInspectionDetails(this.tireStorages[itemIndex]);
    
  }
  
  setInspectionProcessingState(tiresInfo: any[], isLoading: boolean) {
    tiresInfo?.forEach((info: any) => info.isLoading = isLoading);
  }

  async getInspectionDetails(storageItem: any) {
    if(storageItem?.orderInspectionId && !storageItem?.isInspectionChecked) {
      try {
        this.setInspectionProcessingState(storageItem?.tiresInfo, true);
        const actualInspection: any = await this.httpService.getEstimateInspectionDetails(storageItem?.orderInspectionId, storageItem?.storageRO?.orderId, true, true);
        if(actualInspection?.category && actualInspection?.category?.length) {
          const { inspectionItems } = actualInspection?.category[0];
          if(inspectionItems) {
            this.setTiresInfoInspectionData(storageItem?.tiresInfo, inspectionItems);
            storageItem.isInspectionChecked = true;
          }
        }
      } catch(err: any) {
        this.helperService.showToaster('error', err);
      } finally {
        this.setInspectionProcessingState(storageItem?.tiresInfo, false);
      }
    } else {
      if(storageItem.tiresInfo?.length && !storageItem?.orderInspectionId) {
        storageItem.tiresInfo.forEach((info: any) => {
          let treadDepth = info.treadDepth?.includes("/") 
            ? Number(info.treadDepth.split("/")[0])
            : Number(info.treadDepth);
        
          if (treadDepth <= 4) info.isPassed = false;
          if (treadDepth >= 5) info.isPassed = true;
        });
      }
    }  
  }

  setTiresInfoInspectionData(tiresInfo: any[], inspectionItems: any[]) {
    if(tiresInfo?.length) {
      tiresInfo.forEach((info: any) => {
        const insItem =  find(inspectionItems, {tireId: info._id});
        if(insItem) {
          info.isPassed = (insItem.colorIndex === 0);
          info.conditions = insItem.conditions?.filter((condition: any) => condition?.isSelected) || [];
        }
      });
    }
  }

  getTireInfoTread(tireInfo){
    if (tireInfo?.treadDepth?.includes("/")) {
      return Number(tireInfo.treadDepth.split("/")[0]);
    }
    return Number(tireInfo.treadDepth);
  }
}